import { addHook, useFeatureFlags } from '@viveaesthetics/elemy-shared-core'
import {
  useCustomerIOAnalytics,
  useSegmentAnalytics
} from '@viveaesthetics/shared-domain'

import { AnalyticsEvents } from '@/types/analyticsEvents'

export const useEmailAnalytics = addHook({
  useEmailAnalytics: (timeSlot?: Date) => {
    const segmentAnalytics = useSegmentAnalytics<AnalyticsEvents>()
    const customerIOAnalytics = useCustomerIOAnalytics<AnalyticsEvents>()

    const flags = useFeatureFlags()

    const isSegmentClientDataEnabled = flags['pfp-3891-segment-client-data']

    const setEmailAnalytics = ({
      providerId,
      email
    }: {
      providerId: string
      email: string
    }) => {
      customerIOAnalytics.trackEvent(
        AnalyticsEvents.BOOKING_FORM_FIELD_CHANGED,
        {
          fieldName: 'clientInformation.email',
          fieldValue: email
        }
      )

      segmentAnalytics.trackEvent(AnalyticsEvents.BOOKING_FORM_FIELD_CHANGED, {
        fieldName: 'clientInformation.email',
        fieldValue: isSegmentClientDataEnabled ? email : ''
      })

      customerIOAnalytics.identify(email, {
        providerId,
        actualAppointmentTimeSlot: timeSlot
      })

      segmentAnalytics.identify(
        email,
        isSegmentClientDataEnabled
          ? {
              providerId,
              actualAppointmentTimeSlot: timeSlot
            }
          : undefined
      )
    }

    return { setEmailAnalytics }
  }
})
